import React from "react";
import { Image } from "react-bootstrap";
import { TournamentWinner } from "@nestcoinco/hyper-api-gateway-api-client";

import "./LatestWinItem.scss";
import ImageHyperCoin from "../../../images/hyper-coin.svg";
import { getTimeAgo } from "../../../utils/helpers";

function LastWinItem({
  index,
  indexOfItemInView,
  winner,
}: {
  index: number;
  indexOfItemInView: number;
  winner: TournamentWinner;
}) {
  const isCurrentItem = index === indexOfItemInView;

  return (
    <div
      className="winnersDataContainer"
      style={{
        top: isCurrentItem ? 0 : -100,
        bottom: isCurrentItem ? 0 : undefined,
      }}
    >
      <Image src={winner.avatarUrl} alt="user" className="winnerAvatarImg" />
      <p className="winnerInfo">
        @{winner.username} won{" "}
        <Image
          src={ImageHyperCoin}
          alt="hyper coin"
          height="12px"
          width="12px"
        />{" "}
        {winner.tournament?.rewardAmount}{" "}
      </p>
      <span className="separatorDot" />
      <p className="winningTimeText">
        {getTimeAgo(winner.tournament?.endDate)}
      </p>
    </div>
  );
}

export default LastWinItem;
